import React, { useRef } from "react"
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonBackButton,
  IonContent,
  IonTitle,
  IonItem,
  IonLabel,
  IonList,
  IonInput,
  IonButton,
} from "@ionic/react"

import { changePassword } from "../redux/actions"
import { useDispatch } from "react-redux"
import { useHistory } from "react-router-dom"

const ChangePassword: React.FC = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  // const [oldPassword, setOldPassword] = useState<String>("")
  // const [newPassword, setNewPassword] = useState<String>("")
  // const [confirmPassword, setConfirmPassword] = useState<String>("")
  const oldPassword = useRef<HTMLIonInputElement>(null)
  const newPassword = useRef<HTMLIonInputElement>(null)
  const confirmPassword = useRef<HTMLIonInputElement>(null)
  const confirm = () => {
    dispatch(
      changePassword(
        oldPassword.current!.value,
        newPassword.current!.value,
        confirmPassword.current!.value
      )
    )
  }

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/" />
          </IonButtons>
          <IonTitle>Cambio Password</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent class="ion-padding">
        <IonList lines="none">
          <IonItem>
            <IonLabel position="floating">Vecchia password</IonLabel>
            <IonInput
              ref={oldPassword}
              placeholder="Vecchia password"
              type="password"
              value=""
            ></IonInput>
            <IonLabel position="floating">Nuova password</IonLabel>
            <IonInput
              ref={newPassword}
              placeholder="Nuova password"
              type="password"
              value=""
            ></IonInput>
            <IonLabel position="floating">Conferma password</IonLabel>
            <IonInput
              ref={confirmPassword}
              placeholder="Nuova password"
              type="password"
              value=""
            ></IonInput>
          </IonItem>
        </IonList>
        <div className="ion-text-center ion-padding">
          <IonButton expand="block" onClick={() => confirm()}>
            Salva
          </IonButton>
          <IonButton expand="block" fill="outline" onClick={() => history.goBack()}>
            Annulla
          </IonButton>
        </div>
      </IonContent>
    </IonPage>
  )
}

export default ChangePassword
